"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  FETCH_MAGIC_LINK_SITE: "@@records/fetch-magic-link-site",
  FETCH_MAGIC_LINK_REPORT: "@@records/fetch-magic-link-report",
  FETCH_MAGIC_LINK_PASSCODE: "@@records/fetch-magic-link-passcode",
  FETCH_MAGIC_LINK_SITE_EXPORT: "@@records/fetch-magic-link-site-export",
  READ: "@@records/read",
  UPDATE: "@@records/update",
  CREATE: "@@records/create",
  HARD_DELETE: "@@records/hard-delete",
  SOFT_DELETE: "@@records/soft-delete",
  RESTORE: "@@records/restore",
  LIST: "@@records/list",
  LIST_DELETE: "@@records/list-delete",
  UNIQUE_REFERENCE_NO: "@@records/unique-reference-no",
  UNIQUE_URL_EXTENSION: "@@records/unique-url-extension",
  SUCCESS: "@@records/success",
  ERROR: "@@records/error",
  RESET: "@@records/reset",
  UNIQUE_REFERENCE_NO_RESET: "@@records/unique-reference-no-reset",
  UNIQUE_URL_EXTENSION_RESET: "@@records/unique-url-extension-reset",
  RECORD_EXISTS: "@@records/record-exist",
  RECORD_EXISTS_RESET: "@@records/record-exist-reset",
  COPY_SITE_URL: "@@records/copy-site-url",
  COPY_REPORT_URL: "@@records/copy-report-url",
  NOTIFY_UNLOCK_STATUS: "@@records/notifyUnlockStatus",
  RESET_NOTIFY_UNLOCK_STATUS: "@@records/reset_notifyUnlockStatus"
};
exports.actionTypes = actionTypes;